// extracted by mini-css-extract-plugin
export default {"nowrap":"RenderText_nowrap__uGrW-"};